module.exports = __webpack_public_path__ + "img/pengaturan_icon.491ca222.svg";